
import { defineComponent } from 'vue';
import ModalHeader from '@/modules/modals/components/ModalHeader.vue';
import ModalBody from '@/modules/modals/components/ModalBody.vue';
import ModalFooter from '@/modules/modals/components/ModalFooter.vue';
import ModalService from '@/modules/modals/services/modalService';
import IMlsPreviouslyViewed from '@/models/mls/IMlsPreviouslyViewed';
import MlsImportManager from '@/manager/3.6/MlsImportManager';

export default defineComponent({
    components: { ModalHeader, ModalBody, ModalFooter },
    props: ['previouslyVieweds'],
    data() {
        const viewedList: IMlsPreviouslyViewed[] = [...this.$props.previouslyVieweds];

        return {
            modal: null,
            viewedList
        };
    },
    mounted() {
        const modalElement = this.$refs.mlsImportPreviouslyViewed;
        this.modal = ModalService.initialize(modalElement, this);
        ModalService.size(modalElement, '');
        ModalService.open(this.modal);
    },
    methods: {
        getFormatted(previouslyViewed: IMlsPreviouslyViewed): string {
            let address = `${previouslyViewed.address1UnitNoZipCode.address1}`;
            if (previouslyViewed.address1UnitNoZipCode.unitNumber) {
                address += ` ${previouslyViewed.address1UnitNoZipCode.unitNumber}`;
            }
            address += `, ${previouslyViewed.address1UnitNoZipCode.zipCode}`;

            let formatted = '';
            if (previouslyViewed.compNumber === 0) {
                formatted = `Subject - ${address}`;
            } else {
                formatted = `Comp ${previouslyViewed.compNumber} - ${address}`;
            }

            return formatted;
        },
        async runDataPreferences() {
            await MlsImportManager.processToComps(true);

            (this as any).eventBus.emit('checkTabOverflow');
            ModalService.hide(this.modal);
        },
        async closeAndReview() {
            await MlsImportManager.processToComps(false);

            (this as any).eventBus.emit('checkTabOverflow');
            ModalService.hide(this.modal);
        }
    }
});
